import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { account_detail } from '../../redux/actions/accountActions';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import AppBarRegister from '../shared/components/AppBarRegister';
import PrivacyPolicyLink from '../shared/components/PrivacyPolicyLink';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button } from '@material-ui/core';
import RegisterAccountForm from './forms/RegisterAccountForm';
import { common_alertOpen } from '../../redux/actions/commonActions';
import { register,registerVolontarius } from '../../redux/actions/accountActions';
import { signIn } from '../../redux/actions/authActions';
import AccountCreated from './pages/AccountCreated';
import moment from 'moment';
import RegisterConsumerForm from './forms/RegisterConsumerForm';
import { isMobile, isMobileOnly } from 'react-device-detect';
import AppBarPortal from '../shared/components/AppBarPortal';
import queryString from 'query-string';
import AppFooterPortal from '../shared/components/AppFooterPortal';
import AppLeftPortal from '../shared/components/AppLeftPortal';
import AppBarLandingMobile from '../shared/components/AppBarLandingMobile';
import DrawerLandingMobile from '../shared/components/DrawerLandingMobile';

const styles = theme => ({
  root: {
    flexGrow: 1,
    minHeight: '100%'
  },
  flex: {
    flexGrow: 1,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  },
  container: {
    padding: 15,
    height: 'calc(100% - 56px)',
    maxWidth: 500,
    margin: '0 auto'
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
  },
  gridContainer: {
    display: 'flex', 
    justifyContent: 'space-around', 
    alignItems: 'stretch', 
    //flexFlow: 'column wrap',
    height: '100%',
    maxWidth: 500,
    margin: '0 auto'
  },
  gridContainerRow: {
    display: 'flex', 
    justifyContent: 'space-around', 
    alignItems: 'stretch', 
    flexFlow: 'row wrap',
    height: '100%',
  },
  item: {
    flexBasis: 'initial',
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center'
  },
  buttonIndigo: theme.custom.button.indigo,
  buttonIndigoLight: {
    backgroundColor: 'rgba(0,0,255,0.3)',
    color: "#fff"
  },
  colorSwitchBase: {
    color: 'rgb(76,255,182)',
    '&$colorChecked': {
      color: 'rgb(76,255,182)',
      '& + $colorBar': {
        backgroundColor: 'rgb(76,255,182)',
      },
    },
  },
  colorBar: {},
  colorChecked: {},
});

class Register extends React.PureComponent {

  state = {
    value: '',
    nextTo: '',
    step: 0
  };

  handleChange = event => {
    this.setState({ value: event.target.value });
  };

  handleNext = event => {
    if (this.state.value === '') {
      this.props.dispatch(
        common_alertOpen('Please choose something', 'warning')
      );
    } else {
      this.setState({
        nextTo: this.state.value
      })
    }
  }

  changeLayout = (step) => {
    this.setState({
      step: step
    })
  }

  componentDidMount() {
    //alert(window.innerHeight) // 454 in safari
    this.setState({
      value: ''
    });

    const { type } = queryString.parse(this.props.location.search);

    if (typeof type === 'undefined') {

    } else {
      if (type.length === 1) {
        this.setState({
          nextTo: type
        })
      }
    }

    if (this.props.auth.token) {
     this.props.history.push('/account/profile');

    }
    document.body.classList.add("login");
  }

  componentWillUnmount() {
    document.body.classList.remove("login");
  }

  submitVolunteer = values => {
    if (values.birthday) {
      let d = moment(values.birthday)
      values.birthday = d.format('YYYY-MM-DD')
    }
    this.props.dispatch(registerVolontarius(values));

  }

  submitConsumer = values => {
    if (values.birthday) {
      let d = moment(values.birthday)
      values.birthday = d.format('YYYY-MM-DD')
    }
    this.props.dispatch(register(values));
  } 

  render() {
    const { classes, ...other } = this.props;

    if (this.props.account.registered === true) {
      return (
        <React.Fragment>
          {!isMobileOnly && <AppBarPortal />}
          {!isMobileOnly && <AppLeftPortal />}
          {!isMobileOnly && <AppFooterPortal />}
          <AccountCreated accountType={this.state.nextTo} email={this.props.auth.email} />
        </React.Fragment>
      )
  }


    return (
      <React.Fragment>

        {!isMobileOnly && <AppBarPortal />}
        {!isMobileOnly && <AppLeftPortal />}
        {!isMobileOnly && <AppFooterPortal />}

        {this.state.nextTo === '' &&
          <React.Fragment>
            <AppBarRegister {...other} />
            <div className={classes.container}>
              <Grid container className={classes.gridContainer} spacing={8} style={{flexFlow: 'column wrap'}}>
                <Grid item className={classes.item} xs={12} align="center" style={{flexDirection: 'column'}}>
                  <Typography variant="headline" color="textPrimary">
                    Crea tu cuenta
                  </Typography>
                  <Typography variant="caption">
                    Formulario de alta
                  </Typography>
                </Grid>
              
                <Grid item className={classes.item} xs={12}>
                  <Typography variant="display1" color="textPrimary" align="center">
                    Selecciona tu preferencia
                  </Typography>
                </Grid>
              
                <Grid item className={classes.item} xs={12}>
                  <FormControl component="fieldset" margin="none">
                    <RadioGroup
                      aria-label="AccountType"
                      name="account_type"
                      className={classes.group}
                      value={this.state.value}
                      onChange={this.handleChange}
                    >
                      <FormControlLabel value="v" control={<Radio style={{ width: 36, height: 36 }} />} label="Voluntario" spacing={0} />
                      <FormControlLabel value="c" control={<Radio style={{ width: 36, height: 36 }} />} label="Consumidor" margin="none" />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item className={classes.item} xs={12} align="center" style={{flexGrow: 2}}>
                  <Typography variant="caption" component={Link}  to="/how-it-works" style={{textDecoration: 'none'}}>
                    ¿Qué es un Voluntario? ¿Y un Consumidor?
                  </Typography>
                </Grid>

                <Grid item className={classes.item} xs={12} align="center" style={{flexGrow: 3, alignItems: 'flex-end'}}>
                  <Button variant="contained"
                          // color="primary"
                          onClick={this.handleNext}
                          className={this.state.value ? classes.buttonIndigo : classes.buttonIndigoLight}
                  >
                    Siguiente
                  </Button>
                </Grid>

                <Grid item className={classes.item} xs={12} align="center" style={{ alignItems: 'flex-end', justifyContent: 'center'}}>
                  <PrivacyPolicyLink />
                </Grid>

              </Grid>
            </div>
          </React.Fragment>
        }

        {this.state.nextTo === 'v' &&
          <React.Fragment>
            <AppBarRegister 
              hideLogo
              title="Inscripción Voluntario" 
              {...other} 
            />
            <div className={classes.container} style={{height: 'calc(100% - 79px)', paddingBottom: 0}}>
              <Grid container spacing={8} className={this.state.step === 0 ? classes.gridContainer : classes.gridContainerRow}>
                {this.state.step === 0 &&
                <Grid item className={classes.item} xs={12} align="center" style={{flexGrow: 3, justifyContent: 'center', alignItems: 'flex-end'}}>
                  <Typography variant="headline">Crea tu cuenta</Typography>
                </Grid>
                }
                <Grid item className={classes.item} xs={12} style={{flexGrow: 3, justifyContent: 'center'}}>
                  <RegisterAccountForm 
                    changeLayout={this.changeLayout}
                    onSubmit={this.submitVolunteer} 
                    {...other} 
                  />
                </Grid>
                <Grid 
                  item 
                  className={classes.item} 
                  xs={12} 
                  style={{
                    flexGrow: 1, 
                    justifyContent: 'center', 
                    alignItems: 'flex-end',
                    padding: 25
                  }}
                >
                  <PrivacyPolicyLink />
                </Grid>
              </Grid>
            </div>
          </React.Fragment>
        }

        {this.state.nextTo === 'c' &&
        <React.Fragment>
          <AppBarRegister 
            hideLogo
            title="Nuevo Consumidor" 
            {...other} 
          />
          <div className={classes.container} style={{height: 'calc(100% - 79px)', paddingBottom: 0}}>
            <Grid container spacing={8} className={this.state.step === 0 ? classes.gridContainer : classes.gridContainerRow}>
              {this.state.step === 0 &&
              <Grid item className={classes.item} xs={12} align="center" style={{flexGrow: 3, justifyContent: 'center', alignItems: 'flex-end'}}>
                <Typography variant="headline">Crea tu cuenta</Typography>
              </Grid>
              }
              <Grid item className={classes.item} xs={12} style={{flexGrow: 3, justifyContent: 'center'}}>
                <RegisterConsumerForm 
                  changeLayout={this.changeLayout}
                  onSubmit={this.submitConsumer} 
                  {...other} 
                />
              </Grid>
              <Grid 
                item 
                className={classes.item} 
                xs={12} 
                style={{
                  flexGrow: 1, 
                  justifyContent: 'center', 
                  alignItems: 'flex-end',
                  padding: 25
                }}
              >
                <PrivacyPolicyLink />
              </Grid>
            </Grid>
          </div>
        </React.Fragment>
        }

      </React.Fragment>
    )
  }
}

const selector = formValueSelector('registerAccount')
const consumerSelector = formValueSelector('registerConsumerAccount')

const mapStateToProps = state => ({
  auth: state.auth,
  account: state.account,
  common: state.common,
  geo: state.geo,
  countryValue: selector(state, 'country_of_birth'),
  regionValue: selector(state, 'region_of_birth'),
  form_has_different_delivery_address_value: consumerSelector(state, 'has_different_delivery_address'),
  form_work_status_value: consumerSelector(state, 'work_status'),
  form_health_problems_value:consumerSelector(state,'health_problems'),
  form_social_networks:consumerSelector(state,'social_networks'),
  form_consumer_usual_products:consumerSelector(state,'consumer_usual_products'),
  form_buy_products_from:consumerSelector(state,'buy_products_from'),
  form_how_you_know_about_cosmocare_value: consumerSelector(state, 'how_you_know_about_cosmocare'),
  form_using_social_networks_value: consumerSelector(state, 'using_social_networks'),
  form_intolerance_reaction_cosmetics_value: consumerSelector(state, 'intolerance_reaction_cosmetics'),
  form_have_cellulite_value: consumerSelector(state, 'have_cellulite'),
  form_had_eyes_problems_value: consumerSelector(state, 'had_eyes_problems'),
  form_use_hair_removal_products_value: consumerSelector(state, 'use_hair_removal_products'),
  form_has_tattoos_value: consumerSelector(state, 'has_tattoos'),
  form_is_smoking: consumerSelector(state, 'is_smoking'),
  form_had_recent_surgery_value: consumerSelector(state, 'had_recent_surgery'),
  form_disease_type_value: selector(state, 'disease_type'),
  form_other_treatment_value: selector(state, 'other_treatment'), 
  form_had_surgery_value: selector(state, 'had_surgery'), 
  form_skin_affections_value: selector(state, 'skin_affections'), 
  form_has_allergies_value: selector(state, 'has_allergies'),
  form_family_has_allergies_value: selector(state, 'family_has_allergies'),
  form_food_allergies_value: selector(state, 'food_allergies'),
  form_drug_allergies_value: selector(state, 'drug_allergies'),
  form_cosmetic_product_allergies_value: selector(state, 'cosmetic_product_allergies'),
  form_height_value: selector(state, 'height'),
  form_weight_value: selector(state, 'weight'),
  form_smoking_value: selector(state, 'is_smoking'),
  form_tattoos_value: selector(state, 'has_tattoos'),
  form_health_and_care_products_value: selector(state, 'health_and_care_products'),
  form_hair_removal_products_value: selector(state, 'use_hair_removal_products'),
  form_had_laser_hair_removal_value: selector(state, 'had_laser_hair_removal'),
  form_skin_characteristics: consumerSelector(state, 'skin_characteristics'),
});

export default withRouter(
  connect(mapStateToProps)(
    withStyles(styles, {withTheme:true})(Register)
  )
);


// WEBPACK FOOTER //
// ./src/modules/register/Register.js